module.exports = __webpack_public_path__ + "static/media/defi-dark.c462acbc.png";